module.exports = __webpack_public_path__ + "img/gm.8cdda75e.svg";